import environment from "@shared/environment";
import { LogLevel } from "@shared/services/log-level";
var noop = function () { return undefined; };
var logLevel = environment.logLevel;
var LoggerService = /** @class */ (function () {
    function LoggerService() {
    }
    Object.defineProperty(LoggerService.prototype, "debug", {
        get: function () {
            if (logLevel > LogLevel.debug) {
                return noop;
            }
            return console.debug.bind(console);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoggerService.prototype, "info", {
        get: function () {
            if (logLevel > LogLevel.info) {
                return noop;
            }
            return console.info.bind(console);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoggerService.prototype, "warn", {
        get: function () {
            if (logLevel > LogLevel.warning) {
                return noop;
            }
            return console.warn.bind(console);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoggerService.prototype, "error", {
        get: function () {
            if (logLevel > LogLevel.error) {
                return noop;
            }
            return console.error.bind(console);
        },
        enumerable: true,
        configurable: true
    });
    LoggerService.prototype.fatal = function (error) {
        this.error(error);
    };
    return LoggerService;
}());
export default LoggerService;



//////////////////
// WEBPACK FOOTER
// ./app/shared/services/logger.service.ts
// module id = 2
// module chunks = 0 1 2 3 4 5